<template>
  <div class="expandable-text">
    <div
      ref="content"
      :class="{ clamped: !isExpanded }"
      class="text-content"
    >
      {{ text }}
    </div>
    <div class="text-right mt-1">
      <button v-if="isClamped" @click="toggle">
        {{ isExpanded ? 'Ver menos' : 'Ver mais' }}
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, nextTick } from 'vue'

const { text } = defineProps<{
  text: string
}>()

const content = ref<HTMLElement | null>(null)
const isExpanded = ref(false)
const isClamped = ref(false)

const toggle = () => {
  isExpanded.value = !isExpanded.value
}
const checkClamping = () => {
  // Aguarda renderização
  nextTick(() => {
    const el = content.value
    if (el) {
      const isOverflowing = el.scrollHeight > el.clientHeight
      isClamped.value = isOverflowing
    }
  })
}

onMounted(() => {
  checkClamping()
})
</script>

<style scoped>
.text-content {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  transition: max-height 0.3s ease;
}

.clamped {
  -webkit-line-clamp: 3;
}
</style>
